//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import InputlabelBlock from 'components/blocks/InputLabel.vue';


export default {
  block: 'dropDown',
  props: ['data', 'shortHand','invalid'],
  data() {
    return {
      open: false,
      selected: this.data.default,
      content: [{}],
    }
  },
  components: {
    InputlabelBlock,
  },
  methods: {
    openDropDown() {
      this.open = true;
    },
    closeDropDown() {
      this.open = false;
    },
    toggleDropDown() {
      this.open = !this.open;
    },
    select(option) {
      this.selected = option;
      this.$emit('dropDownSelect', option);
    },
  },
}



// WEBPACK FOOTER //
// ./components/blocks/DropDown.vue